export default "__VITE_ASSET__BLaYupvO__"